module.exports = __webpack_public_path__ + "static/media/client-logo-33.f124f9eb.jpg";